export const JoinTeam = () => {
  return (
    <section
      id="join-team"
      data-testid="join-team-section"
      className="relative py-24 sm:py-32 border-t border-hairline"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-serif-display text-pearl text-3xl sm:text-5xl tracking-tight leading-[1.05]">
          Work <span className="italic text-bone">@ W.</span>
        </h2>
        <p className="mt-6 text-[15px] sm:text-[16px] text-ash leading-relaxed max-w-xl mx-auto">
          We&apos;re doing something big in email. If you&apos;re technical and
          want to be a part of our founding team, we&apos;d love to hear from
          you.{" "}
          <a
            href="mailto:hello@w.xyz?subject=Founding%20team%20interest"
            data-testid="join-team-mailto"
            className="text-pearl underline decoration-[var(--w-border)] underline-offset-4 hover:decoration-pearl transition-colors"
          >
            Get in touch
          </a>
          .
        </p>
      </div>
    </section>
  );
};

export default JoinTeam;
